<template>
  <div class="balance-page">
    <!-- 头部区域：包含余额展示与操作入口 -->
    <div class="header-bg">
      <div class="header-content">
        <!-- 顶部栏：左侧标题，右侧操作按钮 -->
        <div class="top-bar">
          <div class="title-label">账户余额 (元)</div>
          <div class="action-buttons">
            <!-- 按钮1：资金流入 -->
            <van-button size="mini" round plain color="#ffffff" icon="plus" @click="openPreStorePopup">
              预存
            </van-button>
            <!-- 按钮2：服务消耗 -->
            <!--   <van-button
              size="mini"
              round
              plain
              color="#ffffff"
              icon="hotel-o"
              @click="handlePackage"
            >
              扫码充值
            </van-button> -->
          </div>
        </div>

        <!-- 中间栏：大字号金额展示 -->
        <div class="amount-container">
          <span class="currency">¥</span>
          <span class="price">{{ balance }}</span>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-card" ref="container">
      <!-- 优化后的通知栏：引导用户充值或查看报表 -->
      <van-notice-bar color="#13227a" background="#ecf9ff" left-icon="volume-o" scrollable>
        温馨提示：点击顶部「预存」可充值；完整报表请使用电脑端查看
      </van-notice-bar>

      <!-- 吸顶的时间筛选栏 -->
      <van-sticky :offset-top="offsetTop" :container="container" @scroll="stickyChange">
        <div class="filter-bar" :class="{ 'is-fixed': stickyChangeFlag }">
          <h3 class="current-date">{{ nowTime }}</h3>
          <div class="icons">
            <van-icon name="notes-o" @click="showPicker = true" />
            <van-icon name="replay" @click="replay" />
          </div>
        </div>
      </van-sticky>

      <!-- 列表组件 -->
      <VANABS :list="list" :paramsList="paramsList" @change="changlist"></VANABS>
    </div>
    <!-- ================= 预存弹窗 (新增) ================= -->
    <van-popup v-model="showPreStorePopup" round position="bottom" :style="{ height: '75%' }" closeable>
      <van-form @submit="onPreStoreSubmit">
        <van-cell-group inset>
          <van-cell
            style="padding-top: 30px; color: #646566; font-size: 16px;"
            title="预存面额"
            :border="false"
          >
            <template #label>
              <span v-if="selectedOption">
                已选择 {{ selectedOption.depositAmountYuan }}元，
                预存{{ selectedOption.depositAmountYuan }}送{{ selectedOption.giftAmountYuan }}
              </span>
              <span v-else style="color: #969799;">请选择预存项</span>
            </template>
          </van-cell>
          <template v-if="amountOptions.length>0">
            <div class="amount-options">
              <van-tag v-for="option in amountOptions" :key="option.ruleId"
                :type="(selectedOption?.ruleId === option.ruleId) ? 'primary' : 'default'" @click="selectRule(option)" :class="{ 'active': (selectedOption?.ruleId === option.ruleId)  }">

                <!-- 限时活动角标：根据 activityType 判断 -->
                <span class="card-badge" v-if="option.activityType == 2">限时</span>

                <!-- 充值金额 -->
                <div class="card-price">{{ option.depositAmountYuan}}元</div>

                <!-- 赠送金额：大于0时显示 -->
                <div class="card-gift" v-if="option.giftAmount > 0">
                  送{{ option.giftAmountYuan }}元
                </div>
              </van-tag>
            </div>
          </template>
          <van-empty v-else description="活动即将上线，敬请期待！" />
        </van-cell-group>

        <div style="margin: 30px 16px;">
          <van-button round block type="primary" native-type="submit" :loading="submitLoading"
            :disabled="selectedOption === null">
            立即支付
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <!-- 日期选择弹窗 -->
    <van-popup v-model="showPicker" position="bottom" round>
      <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" @confirm="onConfirm"
        @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script>
import VANABS from '@/components/BalanceVanPreTab'
import {
  infoAccount,
  infoAccountList,
  infoAccountMoneyPay,
  getUpRulesList
} from '@/api/user.js'
import {
  Toast
} from 'vant'
import * as api from '@/api/api.js'
import { setLocalWithExpiry } from '@/utils/localStorageUtil'

export default {
  components: {
    VANABS
  },
  data () {
    return {
      showPicker: false,
      currentDate: new Date(),
      balance: '0.00', // 默认值防止闪烁
      nowTime: '',
      stickyChangeFlag: false,
      container: null,
      offsetTop: 0,
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        createdAt: ''
      },
      list: [],
      // === 新增：预存弹窗相关数据 ===
      showPreStorePopup: false,
      submitLoading: false,
      amountOptions: [],
      selectedOption: null
    }
  },
  computed: {
    minDate () {
      const time = new Date().getTime()
      return new Date(time - 1000 * 60 * 60 * 24 * 30 * 5)
    },
    maxDate () {
      return new Date()
    }
  },
  created () {
    this.initData()
  },
  mounted () {
    this.container = this.$refs.container
  },
  methods: {
    initData () {
      this.infoAccount()
      this.resetTimeDisplay()
    },
    resetTimeDisplay () {
      const d = new Date()
      this.nowTime = `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`
    },
    // 获取余额
    async infoAccount () {
      try {
        const {
          data: res
        } = await infoAccount({
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0]
        })
        if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login')
          return
        }
        this.balance = res.balance || '0.00'
      } catch (e) {
        console.error(e)
      }
    },
    // 获取预存活动
    async getUpRulesList () {
      try {
        const {
          data: res
        } = await getUpRulesList({
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0]
        })
        this.amountOptions = res.extend.List
        console.log(this.amountOptions)
      } catch (e) {
        console.error(e)
      }
    },
    // === 新增：打开预存弹窗 ===
    openPreStorePopup () {
      this.showPreStorePopup = true
      this.selectedOption = null
      this.getUpRulesList()
    },
    selectRule (value) {
      this.selectedOption = value
    },

    // === 新增：提交预存逻辑 ===
    async onPreStoreSubmit (values) {
      if (isNaN(this.selectedOption?.depositAmount) || isNaN(this.selectedOption?.ruleId)) {
        this.$toast.fail('请选择预存面额')
        return
      }
      this.submitLoading = true
      try {
        const {
          data: res
        } = await infoAccountMoneyPay({
          ruleId: this.selectedOption.ruleId,
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0]
        })
        if (res.code !== 0) {
          return Toast.fail(res.msg)
        }
        const {
          data: ress
        } = await api.payUnifiedOrderV2({
          payId: res.extend.pay.id,
          tradeType: 'JSAPI',
          openId: this.$store.state.openId
        })
        if (ress.code !== 0) {
          return this.$toast(ress.msg) // 使用全局注册的 this.$toast
        }
        if (!ress.extend.payData) {
          return this.$toast('订单获取失败，请稍后重试') // 使用全局注册的 this.$toast
        }
        const payData = ress.extend.payData
        if ('payUrl' in payData) {
          setLocalWithExpiry('currentOrderCode', res.extend.orderCode, 5) // 5分钟
          this.$toast.success('跳转支付页面...')
          this.showPreStorePopup = false
          window.location.href = payData.payUrl
          return
        }
        return Toast('支付失败，请稍后重试') // 使用 import 进来的 Toast
      } catch (error) {
        this.$toast.fail('提交失败，请重试')
      } finally {
        this.submitLoading = false
      }
    },
    // 重置查询
    async replay () {
      try {
        await this.$dialog.confirm({
          title: '温馨提示',
          message: '是否重置查询时间？'
        })
        window.scrollTo(0, 0)
        this.paramsList.createdAt = ''
        this.paramsList.page = 1
        this.resetTimeDisplay()
        await this.fetchList()
      } catch {
        // 取消操作
      }
    },
    formatDate (date) {
      return `${date.getFullYear()}年 ${date.getMonth() + 1}月 ${date.getDate()}日`
    },
    // 确认日期
    async onConfirm (date) {
      window.scrollTo(0, 0)
      this.showPicker = false
      this.nowTime = this.formatDate(date)
      this.paramsList.page = 1

      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      this.paramsList.createdAt = `${year}-${month}-${day}`

      await this.fetchList()
    },
    // 封装列表请求
    async fetchList () {
      const {
        data: res
      } = await infoAccountList(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
        return
      }
      this.list = res.extend.rows || []
      if (this.list.length >= this.paramsList.limit) {
        this.paramsList.page++
      }
    },
    changlist (e) {
      if (e.type === 'add') {
        this.list.push(...e.list)
      } else {
        this.list = []
      }
    },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    }
  }
}
</script>

<style scoped lang="less">
  .balance-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    /* 整体背景色 */
  }

  /* --- 头部区域样式 --- */
  .header-bg {
    /* 替换为你的背景图路径 */
    background: url('~@/assets/benefit-ban-balance-pre.png') no-repeat;
    background-size: 100% 100%;
    padding-bottom: 40px;
    /* 给下方卡片留出重叠空间 */
  }

  .header-content {
    padding: 40px 30px 20px;
    color: #fff;
  }

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title-label {
      font-size: 32px;
      opacity: 0.9;
    }

    .action-buttons {
      display: flex;
      gap: 15px;
      /* 按钮间距 */

      /* 覆盖 Vant 按钮样式，使其更精致 */
      /deep/ .van-button {
        height: 56px;
        padding: 0 24px;
        font-size: 26px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        /* 半透明边框 */
        background: rgba(255, 255, 255, 0.1);
        /* 轻微背景 */
        color: #fff;

        &:active {
          background: rgba(255, 255, 255, 0.3);
        }
      }
    }
  }

  .amount-container {
    text-align: left;
    /* 或者 center，看你喜好 */
    line-height: 1;

    .currency {
      font-size: 40px;
      margin-right: 10px;
      vertical-align: top;
      margin-top: 10px;
      display: inline-block;
    }

    .price {
      font-size: 80px;
      font-weight: bold;
      font-family: DINAlternate-Bold, sans-serif;
      /* 推荐数字字体 */
    }
  }

  /* --- 内容卡片样式 --- */
  .content-card {
    flex: 1;
    margin-top: -30px;
    /* 向上重叠头部 */
    background-color: #fff;
    border-radius: 30px 30px 0 0;
    display: flex;
    flex-direction: column;
  }

  /deep/ .van-notice-bar {
    width: 100%;
    font-size: 26px;
  }

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 35px;
    background-color: #fff;
    transition: all 0.3s;

    h3.current-date {
      font-size: 34px;
      font-weight: bold;
      color: #333;
      margin: 0;
    }

    .icons {
      display: flex;
      gap: 30px;

      .van-icon {
        font-size: 40px;
        color: #666;
      }
    }

    /* 吸顶时的样式变化 */
    &.is-fixed {
      background-color: #13227a;
      /* 变为深蓝底色 */
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

      h3.current-date {
        color: #fff;
      }

      .van-icon {
        color: #fff;
      }
    }
  }
</style>
<style scoped>
  /* =========================================
   1. 外部容器布局
   ========================================= */
  .amount-options {
    display: flex;
    flex-wrap: wrap;
    gap: 20px; /* 【大幅调整】增加卡片间距 */
    padding: 20px 0 30px; /* 【调整】上下内边距加大 */
    justify-content: space-around; /* 【新增】让卡片在容器中居中排列，更美观 */
  }

  /* =========================================
   2. 穿透并覆盖 Vant Tag 的基础样式
   ========================================= */
  ::v-deep .van-tag {
    /* 重置 Vant Tag 默认的 inline 属性，变为卡片容器 */
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;

    /* 【超大幅调整】超大尺寸，确保大手也能轻松点击 */
    width: 160px !important; /* 【大幅调整】从145增加到160 */
    height: 115px !important; /* 【大幅调整】从100增加到115 */
    padding: 26px 0 !important; /* 【大幅调整】内边距加大 */

    margin: 0 !important;

    /* 视觉样式 */
    border-radius: 14px !important; /* 【调整】圆角稍微加大 */
    background-color: #ffffff !important; /* 【调整】背景改为纯白，更清晰 */
    border: 3px solid #ebedf0 !important; /* 【调整】默认边框颜色，提升层次感 */
    color: #333 !important;

    /* 【超大幅调整】基础字体超大，确保清晰易读 */
    font-size: 20px !important; /* 【大幅调整】从18增加到20 */
    line-height: 1.3 !important;

    /* 交互与布局 */
    cursor: pointer;
    position: relative;
    overflow: hidden;   /* 防止右上角的“限时”角标溢出圆角 */
    transition: all 0.2s;
  }

  /* =========================================
   3. 选中状态的高亮效果
   ========================================= */
  ::v-deep .van-tag.active {
    border-color: #1E9FFF !important;
    background-color: #e6f7ff !important;
  }

  ::v-deep .van-tag.active .card-price {
    color: #1E9FFF !important;
  }

  /* =========================================
   4. 卡片内部文字样式（无需穿透，因为写在标签内部）
   ========================================= */
  .card-price {
    font-size: 24px; /* 【大幅调整】充值金额用超大字体 */
    font-weight: bold;
    color: #333;
    margin-bottom: 10px; /* 【调整】增加与赠额的间距 */
  }

  .card-gift {
    font-size: 18px; /* 【大幅调整】赠额字体也超大 */
    color: #d9534f;
  }

  /* =========================================
   5. 右上角限时角标
   ========================================= */
  .card-badge {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #FF6B35; /* 暖橙红 - 更温暖的促销色 */
    color: #fff;
    font-size: 16px; /* 【大幅调整】角标字体超大 */
    padding: 5px 10px; /* 【大幅调整】角标内边距超大 */
    border-radius: 0 14px 0 14px; /* 【调整】角标圆角与卡片圆角呼应 */
    line-height: 1.2;
    z-index: 1;
  }
</style>
